import TravelerAncillaryUIModel from './traveler-ancillary';
import PaidTravelerAncillaryUIModel from './paid-traveler-ancillary';
import TicketedTravelerAncillaryUIModel from './ticketed-traveler-ancillary';
import UpgradeUIModel from './upgrade';
import AncillaryUIModel from './ancillary';
import {
  extraBaggageTypeArray,
  extraBaggageLightTypeArray,
  specialBaggageTypeArray,
} from '../../scripts/constants/ancillary-helpers';
import ANCILLARY_TYPES from '../../scripts/constants/ancillary-types-enum';

class TravelerAncillaryCollectionUIModel {
  constructor({
    _collection = [],
  } = {}) {
    if (_collection) {
      this.ancillaries = [];
      this.hasSomeUnpaidAncillary = false;
      this.hasSomeTicketedAncillaryPP = false;
      let item = null;
      this.ancillaries = _collection.map(ancillary => {
        if (ancillary._meta.class === ANCILLARY_TYPES.PAID_TRAVELER_ANCILLARY) {
          item = new PaidTravelerAncillaryUIModel(ancillary);
        } else if (ancillary._meta.class === ANCILLARY_TYPES.TRAVELER_ANCILLARY) {
          this.hasSomeUnpaidAncillary = !ancillary.ancillary.redeemed && !ancillary.ancillary.redeemedCP ? true : false;
          item = new TravelerAncillaryUIModel(ancillary);
        } else if (ancillary._meta.class === ANCILLARY_TYPES.TICKETED_TRAVELER_ANCILLARY) {
          item = new TicketedTravelerAncillaryUIModel(ancillary);

          if (ancillary?.ancillary?.type === 'PRI' || ancillary?.ancillary?.type === '09T') {
            item.segmentCode = ancillary.segmentCode;
          }

          if (ancillary.ancillary.type === 'UPG') {
            this.hasSomeTicketedAncillary = this.hasSomeTicketedAncillary || !ancillary.ancillary.redeemedCP ? true : false;
          } else {
            this.hasSomeTicketedAncillary = !ancillary.ancillary.redeemed && !ancillary.ancillary.redeemedCP ? true : false;
          }
          this.hasSomeTicketedAncillaryPP = this.hasSomeTicketedAncillaryPP || ancillary.ancillary.redeemedCP;
        } else if (ancillary._meta.class === ANCILLARY_TYPES.CABIN_TRAVELER_ANCILLARY) {
          const newUpgradeAncillaryRequest = {
            ancillaryOffer: ancillary,
            type: 'UPG',
            segmentCode: ancillary.segmentCode,
            quantity: 1,
            redeemedCP: ancillary?.ancillary?.redeemedCP,
            _meta: { class: 'UpgradeAncillary' },
          };
          const ancillaryModel = new UpgradeUIModel(newUpgradeAncillaryRequest);
          const travelerAncillary = new TravelerAncillaryUIModel();
          travelerAncillary.ancillary = ancillaryModel;
          item = travelerAncillary;
        }
        return item;
      });
    }
  }

  getAllUnPaidAncillaries() {
    return this.ancillaries.filter( travelerAncillary => !travelerAncillary.isPaid );
  }

  getAllPaidAncillaries() {
    return this.ancillaries.filter( travelerAncillary => travelerAncillary.isPaid );
  }

  getUnPaidAncillaries() {
    return this.ancillaries.filter( travelerAncillary =>
      travelerAncillary.ancillary &&
      !travelerAncillary.ancillary.redeemedCP &&
      !travelerAncillary.isPaid &&
      !travelerAncillary.hasOwnProperty('emd') &&
      travelerAncillary.getGroupCode() !== 'BG' &&
      travelerAncillary.getType() !== '07X'
    );
  }

  getUnPaiFlyGreenAncillaries() {
    return this.ancillaries.filter(travelerAncillary =>
      travelerAncillary.getType() === '09T' &&
      !travelerAncillary.isPaid
    );
  }

  getUnPaiPRIdAncillaries() {
    return this.ancillaries.filter(travelerAncillary =>
      travelerAncillary.getType() === 'PRI' &&
      !travelerAncillary.isPaid
    );
  }

  getUnPaidAncillariesCP() {
    return this.ancillaries.filter( travelerAncillary =>
      travelerAncillary.ancillary &&
      travelerAncillary.ancillary.redeemedCP &&
      !travelerAncillary.isPaid &&
      !travelerAncillary.hasOwnProperty('emd') &&
      travelerAncillary.getGroupCode() !== 'BG'
    );
  }

  getTicketedAncillaries() {
    return this.ancillaries.filter( travelerAncillary => {
      const flagCBX = travelerAncillary.getGroupCode() !== 'TS' || travelerAncillary.getType() === 'CBX';
      return travelerAncillary.hasOwnProperty('emd') && (travelerAncillary.getGroupCode() !== 'BG' && flagCBX && !travelerAncillary.ancillary.redeemedCP );
    });
  }

  getTicketedAncillariesFlyGreen() {
    return this.ancillaries.filter(travelerAncillary => {
      const isFyGreen = travelerAncillary.getType() === '09T';
      return travelerAncillary?.emd && (isFyGreen && !travelerAncillary?.ancillary?.redeemedCP );
    });
  }

  getTicketedAncillariesPriority() {
    return this.ancillaries.filter(travelerAncillary => {
      const isPriority = travelerAncillary.getType() === 'PRI';
      return travelerAncillary.hasOwnProperty('emd') && (isPriority && !travelerAncillary.ancillary.redeemedCP );
    });
  }

  getTicketedAncillariesPP() {
    return this.ancillaries.filter( travelerAncillary => travelerAncillary.hasOwnProperty('emd') && travelerAncillary.getGroupCode() !== 'BG' && travelerAncillary.ancillary.redeemedCP );
  }

  getTicketedBaggagePP() {
    return this.ancillaries.filter( travelerAncillary => travelerAncillary.hasOwnProperty('emd') && travelerAncillary.getGroupCode() === 'BG' && travelerAncillary.ancillary.redeemedCP );
  }

  hasBagCorporateRedeemed() {
    return this.ancillaries.some(travelerAncillary =>
      travelerAncillary.getGroupCode() === 'BG' &&
      travelerAncillary.redeemedCorporate
    );
  }

  hasBagCorporateRedeemedByLegCode(legCode) {
    return this.ancillaries.some(travelerAncillary =>
      travelerAncillary.legCode === legCode &&
      travelerAncillary.getGroupCode() === 'BG' &&
      travelerAncillary.redeemedCorporate
    );
  }

  hasTicketedUpgrade() {
    const ticketedUpgrades = this.ancillaries.find(travelerAncillary => travelerAncillary.hasOwnProperty('emd') && travelerAncillary.ancillary && travelerAncillary.ancillary.type === 'UPG');
    return ticketedUpgrades && ticketedUpgrades.length !== 0;
  }

  getTicketedUpgradeType() {
    return this.cartConfirmation.getTicketedUpgradeType();
  }

  getTicketedUpgradeSegmentCodes() {
    const segmentCodesArray = [];
    this.ancillaries.forEach(travelerAncillary =>{
      if (travelerAncillary.hasOwnProperty('emd') && travelerAncillary.segmentCode && travelerAncillary.ancillary && travelerAncillary.ancillary.type === 'UPG') {
        segmentCodesArray.push(travelerAncillary.segmentCode);
      }
    });

    return segmentCodesArray;
  }

  getAllTicketedAncillaries() {
    return this.ancillaries.filter( travelerAncillary => travelerAncillary.hasOwnProperty('emd') );
  }

  getAllTicketedCBX() {
    return this.ancillaries.filter(travelerAncillary => travelerAncillary.hasOwnProperty('emd') && travelerAncillary.ancillary.type === '029');
  }

  getBaggageUnPaidAncillaries() {
    return this.ancillaries.filter(travelerAncillary => {
      if (!travelerAncillary.isPaid && !travelerAncillary.ancillaryOffer) {
        return travelerAncillary.getGroupCode() === 'BG' && (extraBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1 || extraBaggageLightTypeArray.indexOf(travelerAncillary.getType()) !== -1) && !travelerAncillary.ancillary.redeemedCP;
      } else if (travelerAncillary.redeemed) {
        travelerAncillary.ancillary = { redeemed: false };

        return travelerAncillary.getGroupCode() === 'BG' && (extraBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1 || extraBaggageLightTypeArray.indexOf(travelerAncillary.getType()) !== -1);
      } else {
        return false;
      }
    });
  }

  getBaggageUnPaidAncillariesPP() {
    return this.ancillaries.filter(travelerAncillary => {
      if (!travelerAncillary.isPaid && !travelerAncillary.ancillaryOffer) {
        return travelerAncillary.getGroupCode() === 'BG' && (extraBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1 || extraBaggageLightTypeArray.indexOf(travelerAncillary.getType()) !== -1) && travelerAncillary.ancillary.redeemedCP;
      } else {
        return false;
      }
    });
  }

  getCarryOnUnPaidAncillaries() {
    return this.ancillaries.filter(travelerAncillary => {
      if (!travelerAncillary.isPaid && !travelerAncillary.ancillaryOffer) {
        return (travelerAncillary.getGroupCode() === 'BG' || travelerAncillary.getGroupCode() === 'TS') && (travelerAncillary.getType() === '0MJ' || travelerAncillary.getType() === '07X' || travelerAncillary.getType() === '0CZ') && !travelerAncillary.ancillary.redeemedCP;
      } else {
        return false;
      }
    });
  }

  getCarryOnUnPaidAncillariesPP() {
    return this.ancillaries.filter(travelerAncillary => {
      if (!travelerAncillary.isPaid && !travelerAncillary.ancillaryOffer) {
        return (travelerAncillary.getGroupCode() === 'BG' || travelerAncillary.getGroupCode() === 'TS') && (travelerAncillary.getType() === '0MJ' || travelerAncillary.getType() === '07X' || travelerAncillary.getType() === '0CZ') && travelerAncillary.ancillary.redeemedCP;
      } else {
        return false;
      }
    });
  }

  getBaggageTicketedAncillaries() {
    return this.ancillaries.filter(travelerAncillary => {
      return travelerAncillary.hasOwnProperty('emd') && travelerAncillary.getGroupCode() === 'BG' && (extraBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1 || extraBaggageLightTypeArray.indexOf(travelerAncillary.getType()) !== -1);
    });
  }

  getCarryOnTicketedAncillaries() {
    return this.ancillaries.filter(travelerAncillary => {
      return travelerAncillary.hasOwnProperty('emd') && (travelerAncillary.getGroupCode() === 'BG' || travelerAncillary.getGroupCode() === 'TS') && (travelerAncillary.getType() === '0MJ' || travelerAncillary.getType() === '07X' || travelerAncillary.getType() === '0CZ');
    });
  }

  getSpecialBaggageUnPaidAncillaries() {
    return this.ancillaries.filter(travelerAncillary => {
      return !travelerAncillary.isPaid && !travelerAncillary.ancillaryOffer && travelerAncillary.getGroupCode() === 'BG' && specialBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1;
    });
  }

  getSpecialBaggageTicketedAncillaries() {
    return this.ancillaries.filter(travelerAncillary => {
      return travelerAncillary.hasOwnProperty('emd') && travelerAncillary.getGroupCode() === 'BG' && specialBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1;
    });
  }

  getBaggageAncillary() {
    return this.ancillaries.filter(travelerAncillary => {
      return travelerAncillary.getGroupCode() === 'BG' && (extraBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1 || extraBaggageLightTypeArray.indexOf(travelerAncillary.getType()) !== -1);
    });
  }

  getCarryOnAncillary() {
    return this.ancillaries.filter(travelerAncillary => {
      return (travelerAncillary.getGroupCode() === 'BG' || travelerAncillary.getGroupCode() === 'TS') && (travelerAncillary.getType() === '0MJ' || travelerAncillary.getType() === '07X' || travelerAncillary.getType() === '0CZ');
    });
  }

  getSpecialBaggageAncillary() {
    return this.ancillaries.filter(travelerAncillary => {
      if (travelerAncillary.hasOwnProperty('ancillaryOffer')) {
        return travelerAncillary.ancillaryOffer.getGroupCode() === 'BG' && specialBaggageTypeArray.indexOf(travelerAncillary.ancillaryOffer.getType()) !== -1;
      } else {
        return travelerAncillary.getGroupCode() === 'BG' && specialBaggageTypeArray.indexOf(travelerAncillary.getType()) !== -1;
      }
    });
  }

  getBaggageAncillaryByLegCode(legCode) {
    return this.getBaggageAncillary().filter(travelerAncillary => {
      return travelerAncillary.legCode === legCode;
    });
  }

  getCarryOnAncillaryByLegCode(legCode) {
    return this.getCarryOnAncillary().filter(travelerAncillary => {
      return travelerAncillary.legCode === legCode;
    });
  }

  getCarryOnAncillaryByLegCode(legCode) {
    return this.getCarryOnAncillary().filter(travelerAncillary => {
      return travelerAncillary.legCode === legCode;
    });
  }

  getSpecialBaggageAncillaryByLegCode(legCode) {
    return this.getSpecialBaggageAncillary().filter(travelerAncillary => {
      return travelerAncillary.legCode === legCode;
    });
  }

  getPaidBaggageAncillaryByLegCode(legCode) {
    return this.getBaggageAncillaryByLegCode(legCode).filter(travelerAncillary => {
      return travelerAncillary.isPaid;
    });
  }

  getPaidCarryOnAncillaryByLegCode(legCode) {
    return this.getCarryOnAncillaryByLegCode(legCode).filter(travelerAncillary => {
      return travelerAncillary.isPaid;
    });
  }

  getPaidSpecialBaggageAncillaryByLegCode(legCode) {
    return this.getSpecialBaggageAncillaryByLegCode(legCode).filter(travelerAncillary => {
      return travelerAncillary.isPaid ;
    });
  }

  getUnpaidBaggageAncillaryByLegCode(legCode) {
    return this.getBaggageAncillaryByLegCode(legCode).filter(travelerAncillary => {
      return !travelerAncillary.isPaid && travelerAncillary.quantity > 0;
    });
  }

  getUnpaidCarryOnAncillaryByLegCode(legCode) {
    return this.getCarryOnAncillaryByLegCode(legCode).filter(travelerAncillary => {
      return !travelerAncillary.isPaid && travelerAncillary.quantity > 0;
    });
  }

  getUnpaidRedeemedBaggageAncillaryByLegCode(legCode) {
    const unPaidBaggageAncillaries = this.getUnpaidBaggageAncillaryByLegCode(legCode);
    return unPaidBaggageAncillaries.filter( travelerAncillary => {
      return travelerAncillary.ancillary.redeemed;
    });
  }

  getUnpaidRedeemedCPBaggageAncillaryByLegCode(legCode) {
    const unPaidBaggageAncillaries = this.getUnpaidBaggageAncillaryByLegCode(legCode);
    return unPaidBaggageAncillaries.filter( travelerAncillary => {
      return travelerAncillary.ancillary.redeemedCP;
    });
  }

  getUnpaidSpecialBaggageAncillaryByLegCode(legCode) {
    return this.getSpecialBaggageAncillaryByLegCode(legCode).filter(travelerAncillary => {
      return !travelerAncillary.isPaid;
    });
  }

  getAncillaryBuilderInstance() {
    return this.ancillaries.filter(travelerAncillary => {
      if (travelerAncillary.hasOwnProperty('ancillaryOffer')) {
        return travelerAncillary.ancillaryOffer.getGroupCode() !== 'BG';
      } else {
        return travelerAncillary.getGroupCode() !== 'BG' || travelerAncillary.getType() === '0CZ';
      }
    });
  }

  /*
   * @param {Array} ancillaries
   * Este método sólo aplica para equipaje
  */
  updateAncillaries(ancillaries, legCode, isCarryOn = false) {
    const unpaidBaggageAncillaries = isCarryOn ? this.getUnpaidCarryOnAncillaryByLegCode(legCode) : this.getUnpaidBaggageAncillaryByLegCode(legCode);
    // Add baggageAncillaries
    if (unpaidBaggageAncillaries.length === 0) {
      ancillaries.forEach(ancillary => {
        if (!ancillary.isPaid) {
          this.hasSomeUnpaidAncillary = !ancillary.redeemed && !ancillary.redeemedCP ? true : false;
          const travelerAncillary = new TravelerAncillaryUIModel(ancillary.toApiTravelerAncillary(legCode));
          travelerAncillary.benefitCodeId = ancillary.benefitCodeId;
          travelerAncillary.ancillary.setRedeemedCorporate(legCode);

          this.ancillaries.push(travelerAncillary);
        }
      });
    } else {
      // Add missing baggageAncillaries
      if (ancillaries.length > unpaidBaggageAncillaries.length) {
        ancillaries.forEach(ancillary => {
          const existUnpaidBaggageAncillary = unpaidBaggageAncillaries.find(unpaidBaggageAncillary =>
            unpaidBaggageAncillary.ancillary.type === ancillary.type && unpaidBaggageAncillary.legCode === legCode
          );

          if (!existUnpaidBaggageAncillary) {
            const travelerAncillary = new TravelerAncillaryUIModel(ancillary.toApiTravelerAncillary(legCode));
            travelerAncillary.benefitCodeId = ancillary.benefitCodeId;
            travelerAncillary.ancillary.setRedeemedCorporate(legCode);
            this.ancillaries.push(travelerAncillary);
          }
        });
      } else { // Remove ancillaries
        const typesUnpaidAncillaries = unpaidBaggageAncillaries.map(travelerAncillary => {
          return travelerAncillary.ancillary.type;
        });
        const typesAncillaries = ancillaries.map(ancillary => {
          return ancillary.type;
        });

        typesUnpaidAncillaries.forEach((typeAncillary, index) => {
          if (!typesAncillaries.includes(typeAncillary)) {
            unpaidBaggageAncillaries[index].quantity = 0;
          }
        });

        ancillaries.forEach(ancillary => {
          const existUnpaidBaggageAncillary = unpaidBaggageAncillaries.find(unpaidBaggageAncillary =>
            unpaidBaggageAncillary.ancillary.type === ancillary.type && unpaidBaggageAncillary.legCode === legCode
          );

          if (!existUnpaidBaggageAncillary) {
            const travelerAncillary = new TravelerAncillaryUIModel(ancillary.toApiTravelerAncillary(legCode));
            travelerAncillary.benefitCodeId = ancillary.benefitCodeId;
            this.ancillaries.push(travelerAncillary);
          }
        });

        ancillaries.forEach(ancillary => {
          const unpaidBaggage = unpaidBaggageAncillaries.find( unpaidBag => unpaidBag.ancillary.type === ancillary.type );
          if (unpaidBaggage !== undefined) {
            if (ancillary.redeemed) {
              unpaidBaggage.quantity = 1;
              unpaidBaggage.benefitCodeId = ancillary.benefitCodeId;
              unpaidBaggage.ancillary.redeemed = true;
            }
            unpaidBaggage.ancillary.redeemedCP = ancillary.redeemedCP;
          }
        });
      }
    }
  }

  toApi() {
    return {
      '_meta':{
        'class': 'BookedTravelerAncillaryCollection',
      },
      '_collection': this.ancillaries.map(ancillary => {
        return ancillary.toApi();
      }),
    };
  }

  addAncillary(ancillary, legCode = null, isRedeemedCP = false) {
    const isUpg = ancillary.ancillary && ancillary.ancillary.type === 'UPG';
    const isPriority = ancillary?.ancillary?.type === 'PRI';
    const isFlyGreen = ancillary?.ancillary?.type === '09T';
    const isCBX = ancillary?.type === '029';
    const existsAnc = isUpg || isPriority || isFlyGreen ? false : !!this.ancillaries.find( (item) => item?.ancillary?.type === ancillary.type && (ancillary.type !== '029' || (ancillary.type === '029' && ancillary.legCode === legCode)) );
    const existsAncUpg = isUpg ? !!this.ancillaries.find(item => item.ancillary && item.ancillary.ancillaryOffer && item.ancillary.ancillaryOffer.ancillary && item.ancillary.ancillaryOffer.ancillary.type === ancillary.ancillary.type && item.ancillary.segmentCode === ancillary.segmentCode) : false;
    const existsAncPRI = isPriority ? !!this.ancillaries.find(item => item?.ancillary?.type === ancillary?.ancillary?.type && item?.segmentCode === ancillary?.segmentCode) : false;
    const existsAncFlyGreen = isFlyGreen ? !!this.ancillaries.find(item => item?.ancillary?.type === ancillary?.ancillary?.type && item?.segmentCode === ancillary?.segmentCode) : false;
    const validateStateChubb = ancillary && ancillary?.type === 'SVI' ? ancillary?.validateStateChubb : null;

    if (existsAnc) {
      this.ancillaries.forEach(item => {
        if (item.ancillary && item.ancillary.type === ancillary.type) {
          item.ancillary.redeemedCP = isRedeemedCP;
        }
        if (item.ancillary && item.ancillary.type === 'SVI') {
          item.ancillary.currency = ancillary.currency;
          item.ancillary.validateStateChubb = validateStateChubb;
        }
      });
    } else {
      if (isUpg) {
        if (!existsAncUpg) {
          const newUpgradeAncillaryRequest = {
            ancillaryOffer: ancillary,
            type: 'UPG',
            quantity: 1,
            segmentCode: ancillary.segmentCode,
            redeemedCP: ancillary?.ancillary?.redeemedCP,
            _meta: { class: 'UpgradeAncillary' },
          };

          newUpgradeAncillaryRequest.ancillaryOffer.ancillary.redeemedCP = isRedeemedCP;

          const ancillaryModel = new UpgradeUIModel(newUpgradeAncillaryRequest);
          const travelerAncillary = new TravelerAncillaryUIModel();
          travelerAncillary.ancillary = ancillaryModel;
          this.ancillaries.push(travelerAncillary);
        } else {
          this.ancillaries.forEach(item => {
            if (item.ancillary && item.ancillary.type === 'UPG' && item.ancillary.segmentCode && item.ancillary.segmentCode === ancillary.segmentCode) {
              item.ancillary.ancillaryOffer.ancillary.redeemedCP = isRedeemedCP;
            }
          });
        }
      } else if (isPriority || isFlyGreen) {
        if (!existsAncPRI || !existsAncFlyGreen) {
          const ancillaryModel = new AncillaryUIModel(ancillary?.ancillary);
          const travelerAncillary = new TravelerAncillaryUIModel();
          travelerAncillary.ancillary = ancillaryModel;
          travelerAncillary.quantity = 1;
          travelerAncillary.legCode = ancillary.legCode;
          travelerAncillary.segmentCode = ancillary.segmentCode;

          this.ancillaries.push(travelerAncillary);
        } else {
          if (isFlyGreen) {
            this.ancillaries.forEach(item => {
              if (item?.ancillary?.type === '09T' && item?.segmentCode === ancillary?.segmentCode) {
                item.ancillary.redeemedCP = isRedeemedCP;
              }
            });
          } else if (isPriority) {
            this.ancillaries.forEach(item => {
              if (item?.ancillary?.type === 'PRI' && item?.segmentCode === ancillary?.segmentCode) {
                item.ancillary.redeemedCP = isRedeemedCP;
              }
            });
          }
        }
      } else if (isCBX && legCode) {
        const ancillaryModel = new AncillaryUIModel(ancillary);
        const travelerAncillary = new TravelerAncillaryUIModel();
        const currencyPerLeg = ancillaryModel?.currencyPerLegArray?.find(currency => currency?.legCode === legCode);

        if (currencyPerLeg?.currency) {
          ancillaryModel.currency.base = currencyPerLeg?.currency?.base;
          ancillaryModel.currency.total = currencyPerLeg?.currency?.total;
          ancillaryModel.currency.totalCPPoints = currencyPerLeg?.currency?.totalCPPoints;
        }

        travelerAncillary.ancillary = ancillaryModel;
        travelerAncillary.ancillary.redeemedCP = isRedeemedCP;
        travelerAncillary.quantity = 1;
        travelerAncillary.legCode = legCode;
        travelerAncillary.segmentCode = '';

        this.ancillaries.push(travelerAncillary);
      } else {
        const ancillaryModel = new AncillaryUIModel(ancillary);
        const travelerAncillary = new TravelerAncillaryUIModel();

        travelerAncillary.ancillary = ancillaryModel;
        travelerAncillary.ancillary.redeemedCP = isRedeemedCP;
        travelerAncillary.quantity = 1;
        travelerAncillary.legCode = legCode;
        travelerAncillary.segmentCode = '';

        this.ancillaries.push(travelerAncillary);
      }
    }

    this.hasSomeUnpaidAncillary = true;
  }

  removeUpgradeAncillary(ancillary) {
    this.ancillaries.filter(ancillary => !ancillary.isPaid).forEach(item => {
      if (ancillary.segmentCode === item.ancillary.segmentCode) {
        item.ancillary.quantity = 0;
      }
    });
  }

  removePriorityAncillary(ancillary) {
    this.ancillaries.filter(ancItem => !ancItem.isPaid).forEach(item => {
      if (ancillary.segmentCode === item.segmentCode) {
        item.quantity = 0;
      }
    });
  }

  removeAncillary(ancillaryType, legCode) {
    ancillaryType = ancillaryType === '029' ? 'CBX' : ancillaryType;
    this.ancillaries.forEach( item => {
      let validItem = false;
      if (ancillaryType === 'CBX') {
        validItem = !item.isPaid && item.ancillary.type === '029' && item.legCode === legCode;
      } else {
        validItem = legCode ? !item.isPaid && item.ancillary.type === ancillaryType && item.legCode === legCode
          : !item.isPaid && item.ancillary.type === ancillaryType;
      }

      if (validItem) {
        item.quantity = 0;
        item.ancillary.redeemedCP = false;
      }
    });
  }
}

export default TravelerAncillaryCollectionUIModel;
